import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import {
  getUsers,
  saveUser,
  editUser,
  deleteUser,
  resetPassword,
  resetForms,
} from "../../redux/auth/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import CheckActiveUser from "../../components/users/CheckActiveUser";

// import MultiSelect from "../../components/Clima/Multiselect";
import CustomPagint from "../../components/CustomPagint";
import Multiselect from "../../components/MultiselectFormik";

const schemaUsers = Yup.object().shape({
  username: Yup.string()
    .test("codigo-format", "**Solo admite letras y números", (value) => {
      // Lógica de temporizador para la validación
      if (value === "" || !value) {
        return true; // Campo vacío, no validamos todavía
      }

      if (value.length < 1) {
        return true; // No validamos hasta que se escriban al menos 1 caracter
      }

      // Aquí puedes definir tu patrón personalizado
      const pattern = /[0-9]{5,40}/;
      return pattern.test(value);
    })
    .required("**Campo requerido"),
  first_name: Yup.string()
    .test("codigo-format", "**Solo admite letras", (value) => {
      // Lógica de temporizador para la validación
      if (value === "" || !value) {
        return true; // Campo vacío, no validamos todavía
      }

      if (value.length < 1) {
        return true; // No validamos hasta que se escriban al menos 1 caracter
      }

      // Aquí puedes definir tu patrón personalizado
      const pattern = /^[a-zA-Z\s]+$/;
      return pattern.test(value);
    })
    .required("**Campo requerido"),
  last_name: Yup.string()
    .test("codigo-format", "**Solo admite letras", (value) => {
      // Lógica de temporizador para la validación
      if (value === "" || !value) {
        return true; // Campo vacío, no validamos todavía
      }

      if (value.length < 1) {
        return true; // No validamos hasta que se escriban al menos 1 caracter
      }

      // Aquí puedes definir tu patrón personalizado
      const pattern = /^[a-zA-Z\s]+$/;
      return pattern.test(value);
    })
    .required("**Campo requerido"),
  email: Yup.string()
    .email("**Se require un correo electrónico valido")
    .required("**Campo requerido"),
  password: Yup.string().required("**Campo requerido"),
  groups: Yup.array().test({
    message: "**Campo requerido",
    test: (val) => val.length !== 0,
  }),
});

const schema = Yup.object().shape({
  usuario: Yup.string().notRequired(),
  email: Yup.string().notRequired(),
  password: Yup.string()
    .matches(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/,
      "Debe contener 8 caracteres, uno en mayúscula, uno en minúscula, un número y un carácter de caso especial."
    )
    .required("**Campo requerido"),
  rePassword: Yup.string()
    .required("**Campo requerido")
    .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir"),
});

const Users = () => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [filter, setFilter] = useState("");
  // const [validated, setValidated] = useState(false);
  const [seePass, setSeePass] = useState(false);
  const [seeRePass, setSeeRePass] = useState(false);
  const [show, setShow] = useState(false);
  const [groupsVal, setGroupsVal] = useState([]);
  // const [validGroup, setValidGroup] = useState(true);
  // const [submitGroup, setSubmitGroup] = useState(false);

  const dispatch = useDispatch();

  const {
    users,
    roles,
    usersLength,
    loadingAuth,
    saveLoading,
    loaderResetPass,
    formError,
    formPasswordError,
    userError,
  } = useSelector((store) => store.auth);
  const pages = Math.ceil(usersLength / limit);

  var userGroups = [];

  roles.map((item) => {
    userGroups = [...userGroups, { value: item.id, label: item.name }];
  });

  const columns = [
    {
      Header: "Usuario",
      accessor: "username",
    },
    {
      Header: "Nombre",
      accessor: "first_name",
    },
    {
      Header: "Apellido",
      accessor: "last_name",
    },
    {
      Header: "Correo electrónico",
      accessor: "email",
    },
    {
      id: "customActive",
      Header: "",
      Filter: "",
      Cell: (value) => (
        <CheckActiveUser row={value.row.original} index={value.row.index} />
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          <Button
            size="sm"
            className="text-success"
            variant="link"
            type="button"
            onClick={() =>
              onEditChangePassword(value.row.original, value.row.index)
            }
          >
            <i className="material-icons">password</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getAUsers = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getUsers({
        offset: offs,
        limit: lim,
        filter: filt,
      })
    );

  useEffect(() => {
    getAUsers();
  }, []);

  const onAdd = () => {
    dispatch(resetForms());
    setShowModal(true);
    setEdit(false);
    setEditItem({});
    // setValidated(false);
    // setValidGroup(true);
    setGroupsVal([]);
  };

  const onEdit = (item, index) => {
    dispatch(resetForms());
    var groupEdit = [];
    item.groups.map((item) => {
      groupEdit = [...groupEdit, { value: item }];
    });
    setGroupsVal(groupEdit);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    // setValidated(false);
    // setValidGroup(true);
  };

  const onEditChangePassword = (item, index) => {
    dispatch(resetForms());
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModalPassword(true);
    // setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAUsers(oOffset, limit, e.target.filter.value);
  };

  // const evaluarValues = (valor) => {
  //   if (valor.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };
  const onSubmit = (req) => {
    // e.preventDefault();
    // const form = e.currentTarget;
    // setSubmitGroup(true);
    // setValidGroup(evaluarValues(groupsVal));
    // if (form.checkValidity() === false || groupsVal.length === 0) {
    //   setValidated(true);
    //   return;
    // }
    var groupTemp = [];
    req.groups.map((item) => {
      groupTemp = [...groupTemp, parseInt(item.value)];
    });
    req.groups = groupTemp;
    // const req = {
    //   username: e.target.username.value,
    //   first_name: e.target.firstname.value,
    //   last_name: e.target.lastname.value,
    //   email: e.target.email.value,
    //   password: e.target.password.value,
    //   groups: groupTemp,
    // };
    if (!edit) {
      dispatch(saveUser(req, setShowModal, setGroupsVal));
      // e.target.reset();
      // setShowModal(false);
      // setGroupsVal([]);
      // setValidGroup(true);
      // setSubmitGroup(false);
    } else {
      dispatch(editUser(req, editItem.id, index, setShowModal, setGroupsVal));
      // setShowModal(false);
      // setGroupsVal([]);
      // setValidGroup(true);
      // setSubmitGroup(false);
    }
    // setShowModal(false);
  };

  const onSubmitChancePassword = (values) => {
    const req = {
      username: values.usuario,
      password: values.password,
      email: values.email,
    };
    dispatch(resetPassword(req, setShowModalPassword));
    // setShowModalPassword(false);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAUsers(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteUser(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 class="font-weight-bold text-uppercase">Usuarios</h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!userError && !loadingAuth && (
            <Alert variant="danger" className="m-2">
              {userError}
            </Alert>
          )}
          {loadingAuth ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : usersLength > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={users} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={usersLength}
                pages={pages}
                pagFunc={getAUsers}
              />
            </>
          ) : (
            <>
              {userError === "" && (
                <Alert variant="info" className="my-4">
                  Aún no hay usuarios, comienza agregando algunos
                </Alert>
              )}
            </>
          )}
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          // setSubmitGroup(false);
        }}
      >
        <Formik
          validationSchema={schemaUsers}
          onSubmit={onSubmit}
          initialValues={{
            username: edit ? editItem.username : "",
            first_name: edit ? editItem.first_name : "",
            last_name: edit ? editItem.last_name : "",
            email: edit ? editItem.email : "",
            password: edit ? editItem.password : "",
            groups: edit ? groupsVal : [],
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar usuario" : "Crear usuario"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Usuario
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="username"
                      name="username"
                      isInvalid={touched.username && errors.username}
                      isValid={touched.username && !errors.username}
                      onBlur={handleBlur("username")}
                      onChange={handleChange}
                      value={values.username}
                      className="rounded-pill"
                      type="text"
                      placeholder="Usuario"
                      disabled={edit}
                      // pattern="[0-9]{5, 40}"
                    ></Form.Control>
                    {touched.username && errors.username && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.username}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras y números
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="first_name"
                      name="first_name"
                      isInvalid={touched.first_name && errors.first_name}
                      isValid={touched.first_name && !errors.first_name}
                      onBlur={handleBlur("first_name")}
                      onChange={handleChange}
                      value={values.first_name}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre"
                      // pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                    ></Form.Control>
                    {touched.first_name && errors.first_name && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.first_name}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Apellido
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="last_name"
                      name="last_name"
                      isInvalid={touched.last_name && errors.last_name}
                      isValid={touched.last_name && !errors.last_name}
                      onBlur={handleBlur("last_name")}
                      onChange={handleChange}
                      value={values.last_name}
                      className="rounded-pill"
                      type="text"
                      placeholder="Apellido"
                    ></Form.Control>
                    {touched.last_name && errors.last_name && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.last_name}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Correo electrónico
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="email"
                      name="email"
                      isInvalid={touched.email && errors.email}
                      isValid={touched.email && !errors.email}
                      onBlur={handleBlur("email")}
                      onChange={handleChange}
                      value={values.email}
                      className="rounded-pill"
                      type="email"
                      placeholder="Correo electrónico"
                    ></Form.Control>
                    {touched.email && errors.email && (
                      // <div>
                      <small className="mx-2 text-danger">{errors.email}</small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Se require un correo electrónico valido
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Contraseña
                  </Form.Label>
                  <Col sm="12" md="8">
                    <div className="input-group">
                      <Form.Control
                        id="password"
                        name="password"
                        isInvalid={touched.password && errors.password}
                        isValid={touched.password && !errors.password}
                        onBlur={handleBlur("password")}
                        onChange={handleChange}
                        value={values.password}
                        // className="rounded-pill"
                        type={seePass ? "text" : "password"}
                        placeholder="Correo electrónico"
                        disabled={edit}
                        style={{
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                      ></Form.Control>
                      <div class="input-group-prepend">
                        <Button
                          disabled={edit}
                          onClick={() => setSeePass(!seePass)}
                          class="input-group-text"
                          variant="secondary"
                          style={{
                            borderBottomRightRadius: "20px",
                            borderTopRightRadius: "20px",
                            cursor: "pointer",
                          }}
                        >
                          <i className="material-icons">
                            {seePass ? "visibility" : "visibility_off"}
                          </i>
                        </Button>
                      </div>
                    </div>
                    {touched.password && errors.password && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.password}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Grupo
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Row className="align-items-center">
                      <Col sm={loadingAuth ? "10" : "12"}>
                        {/* <MultiSelect
                          options={userGroups}
                          value={groupsVal}
                          onChange={setGroupsVal}
                          isValid={validGroup}
                          isDisabled={false}
                          isSubmit={submitGroup}
                        /> */}
                        <Multiselect
                          id="groups"
                          name="groups"
                          options={userGroups}
                          value={values.groups}
                          onChange={(selected) => {
                            setFieldValue(
                              "groups",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.groups && !errors.groups}
                          isInvalid={touched.groups && errors.groups}
                          onBlur={() => handleBlur("groups")}
                        />
                        {touched.groups && errors.groups && (
                          // <div>
                          <small className="mx-2 text-danger">
                            {errors.groups}
                          </small>
                          // </div>
                        )}
                        {/* {!validGroup && (
                          <Col style={{ color: "red", fontSize: "12px" }}>
                            **Campo requerido
                          </Col>
                        )} */}
                      </Col>
                      {loadingAuth && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalPassword}
        onHide={() => {
          setShowModalPassword(false);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitChancePassword}
          initialValues={{
            usuario: edit ? editItem.username : "",
            email: edit ? editItem.email : "",
            password: "",
            rePassword: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Cambiar contraseña de usuario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formPasswordError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formPasswordError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Usuario
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      disabled
                      className="rounded-pill"
                      name="usuario"
                      type="text"
                      value={values.usuario}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.usuario && !!errors.usuario}
                      placeholder="Correo electrónico"
                    ></Form.Control>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Correo electrónico
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      disabled
                      name="email"
                      className="rounded-pill"
                      required
                      type="email"
                      value={values.email}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.email && !!errors.email}
                      placeholder="Correo electrónico"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Contraseña
                  </Form.Label>
                  <Col sm="12" md="8">
                    <div className="input-group">
                      <Form.Control
                        style={{
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        name="password"
                        required
                        type={seePass ? "text" : "password"}
                        onChange={(e) => handleChange(e)}
                        value={values.password}
                        isInvalid={touched.password && !!errors.password}
                        placeholder="Contraseña"
                      ></Form.Control>
                      <div class="input-group-prepend">
                        <Button
                          onClick={() => setSeePass(!seePass)}
                          class="input-group-text"
                          variant="secondary"
                          style={{
                            borderBottomRightRadius: "20px",
                            borderTopRightRadius: "20px",
                            cursor: "pointer",
                          }}
                        >
                          <i className="material-icons">
                            {seePass ? "visibility" : "visibility_off"}
                          </i>
                        </Button>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Repetir contraseña
                  </Form.Label>
                  <Col sm="12" md="8">
                    <div className="input-group">
                      <Form.Control
                        style={{
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        name="rePassword"
                        required
                        type={seeRePass ? "text" : "password"}
                        onChange={handleChange}
                        value={values.rePassword}
                        isInvalid={!!errors.rePassword}
                        placeholder="Repetir contraseña"
                      ></Form.Control>
                      <div class="input-group-prepend">
                        <Button
                          onClick={() => setSeeRePass(!seeRePass)}
                          class="input-group-text"
                          variant="secondary"
                          style={{
                            borderBottomRightRadius: "20px",
                            borderTopRightRadius: "20px",
                            cursor: "pointer",
                          }}
                        >
                          <i className="material-icons">
                            {seeRePass ? "visibility" : "visibility_off"}
                          </i>
                        </Button>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.rePassword}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalPassword(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={loaderResetPass}
                  variant="primary"
                  type="submit"
                >
                  {loaderResetPass ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Users;
